export default __webpack_public_path__ + "static/media/aiadmk.8d512981.png";